import { detail } from "@mc/mc-legacy";
import RegistraceApi from "../api/gen/core/RegistraceApi";
export const USER_REGISTRATION_INFO_DETAIL_AREA = "userRegistrationInfo";
export function fetchRegistrationInfoIfNeeded(key) {
  return (dispatch) => {
    dispatch(
      detail.DetailActions.fetchIfNeeded(USER_REGISTRATION_INFO_DETAIL_AREA, key, (key) => {
        return RegistraceApi.getOidcUserInfo(key);
      })
    );
  };
}
